exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "section.section__login {\n  padding: 40px 0;\n}\n\n/** Media Queries **/\n\n@media (max-width: 450px) {\n  .section__login {\n    padding-top: 0px;\n    margin-top: 0px;\n  }\n  .section__login .w-col-12 {\n    padding: 0px;\n  }\n}\n\n.gotozoom {\n  background-image: linear-gradient(45deg, rgba(0, 115, 180, 0.4), #fff 66%);\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/pages/account-request-page/account-request-page.component.scss
// module id = ../../../../../src/app/pages/account-request-page/account-request-page.component.scss
// module chunks = main